import {Component, ElementRef, forwardRef, OnInit} from "@angular/core";
import {mixinDestroyable, mixinSpinnerAndToast} from "../../../../lib";
import {DashboardModuleDirective, DashboardModuleDirectiveInputs} from "../../directives";
import {DashboardModuleButtonAction, DashboardModuleButtonType, DashboardModuleType} from "fello-model";
import {AbstractDashboardService} from "../../services";
import {takeUntil, tap} from "rxjs/operators";
import {NgxSpinnerService} from "ngx-spinner";
import {MatSnackBar} from "@angular/material/snack-bar";

const VendorBaseComponent = mixinDestroyable(
  mixinSpinnerAndToast(
    class extends DashboardModuleDirective<DashboardModuleType.LENDER> {
      constructor(public spinnerService: NgxSpinnerService, public snackBar: MatSnackBar, elementRef: ElementRef) {
        super(elementRef);
      }
    }
  )
);

@Component({
  selector: "lib-lender",
  templateUrl: "./vendor.component.html",
  styleUrls: ["./vendor.component.scss"],
  inputs: DashboardModuleDirectiveInputs,
  providers: [
    {
      provide: DashboardModuleDirective,
      useExisting: forwardRef(() => VendorComponent)
    }
  ]
})
export class VendorComponent extends VendorBaseComponent implements OnInit {
  isLoading = true;
  DashboardModuleButtonType = DashboardModuleButtonType;

  constructor(
    private dashboardService: AbstractDashboardService,
    spinnerService: NgxSpinnerService,
    snackBar: MatSnackBar,
    elementRef: ElementRef
  ) {
    super(spinnerService, snackBar, elementRef);
  }

  ngOnInit() {
    this.dashboardService.isPropertyLoading
      .pipe(
        takeUntil(this.isDestroyed),
        tap(val => (this.isLoading = val))
      )
      .subscribe(
        () => {},
        () => (this.isLoading = false)
      );
  }

  performCTAAction(action: DashboardModuleButtonAction): void {
    this.withSpinner(this.dashboardService.performCTAAction(action)).subscribe();
  }
}
